import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import Link from '../Link';

import FacebookSVG from '../../svg/icons/facebook.svg';
import InstagramSVG from '../../svg/icons/instagram.svg';
import TwitterSVG from '../../svg/icons/twitter.svg';
import SnapchatSVG from '../../svg/icons/snapchat.svg';

import './IconSocialMedia.scss';

const socialMap = {
  facebook: {
    url: 'https://facebook.com/',
    Logo: FacebookSVG,
  },
  instagram: {
    url: 'https://instagram.com/',
    Logo: InstagramSVG,
  },
  twitter: {
    url: 'https://twitter.com/',
    Logo: TwitterSVG,
  },
  snapchat: {
    url: 'https://snapchat.com/',
    Logo: SnapchatSVG,
  },
};

const IconSocialMedia = (props) => {
  const {
    handleLinkClick, providers, venue,
  } = props;

  if (!providers.length) return null;

  return (
    <div className="IconSocialMedia">
      {providers.map((provider) => {
        const socialSite = socialMap[provider.name];
        const to = `${socialSite.url}${provider.value}`;
        const isValidUrl = /^https?:\/\/.+/.test(provider.value);
        const href = isValidUrl ? provider.value : to;

        return (
          <Link
            href={href}
            onClick={() => handleLinkClick(provider.name)}
            target="_blank"
            key={provider.name}
            aria-label={`${venue} ${provider.name}`}
          >
            <Icon
              width="20"
              component={socialSite.Logo}
              iconClass={provider.name}
            />
          </Link>
        );
      })}
    </div>
  );
};

IconSocialMedia.propTypes = {
  handleLinkClick: PropTypes.func,
  providers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    value: PropTypes.string,
  })),
  venue: PropTypes.string.isRequired,
};

IconSocialMedia.defaultProps = {
  handleLinkClick: () => {},
  providers: [],
};

IconSocialMedia.displayName = 'IconSocialMedia';
export default IconSocialMedia;
